import {CartController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {ApplePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_applepay_data');

const context = new Context('cart');

const gateway = new ApplePayGateway({
    id: 'stripe_applepay',
    settings,
    context
});

const controller = new CartController({
    context,
    gateway,
    selector: '#wc-stripe_applepay-cart-button'
});

controller.initialize();